module.exports = __webpack_public_path__ + "img/1009.0e46882d.jpg";